// extracted by mini-css-extract-plugin
export var numpadContainer = "_ja-1";
export var phoneButton = "_ja-0";